// extracted by mini-css-extract-plugin
export default {"container":"LoadingIndicator_container__2xqFb","spinner":"LoadingIndicator_spinner__ZfiHV","spin":"LoadingIndicator_spin__RxHH1"};